"use client";

import { useEffect, useState } from "react";

import {
  DEFAULT_LANGUAGE,
  resolveLangFromPathname,
} from "@/utils/library/languages";
import {
  loadGlobalErrorCopy,
  type GlobalErrorCopy,
} from "@/utils/globalErrorCopy";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

function resolveLang(): string {
  if (globalThis.window === undefined) {
    return DEFAULT_LANGUAGE;
  }
  return resolveLangFromPathname(globalThis.location.pathname);
}

export default function GlobalError({ reset }: Readonly<GlobalErrorProps>) {
  const lang = resolveLang();
  const [copy, setCopy] = useState<GlobalErrorCopy | null>(null);

  useEffect(() => {
    let cancelled = false;

    void loadGlobalErrorCopy(lang).then((loaded) => {
      if (!cancelled) {
        setCopy(loaded);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [lang]);

  return (
    <html lang={lang}>
      <head>
        <title>{copy?.title ?? "Something went wrong"}</title>
      </head>
      <body>
        <main aria-busy={copy === null}>
          {copy ? (
            <>
              <h1>{copy.title}</h1>
              <p>{copy.description}</p>
              <button type="button" onClick={reset}>
                {copy.tryAgain}
              </button>
            </>
          ) : null}
        </main>
      </body>
    </html>
  );
}
